import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../../Utils/GlobalUtils';

import Loading from '../../../Loading'

import styles from '../../../../styles/DynamicModal.module.css';

import IconContainer from '../../../IconContainer';
import { ReactComponent as XIcon } from '../../../../icons/x-close.svg';

const EditInsuranceCase = ({ closeModal, caseId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        date_am_exam: '',
        special_debtors_categories: '',
        admission_form: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-main-case-insurance?case_id=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setFormInfo(response.data);
            setStatus(null);
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };
    const handleAssetValueGovChange = (e) => {
        let value = e.target.value;

        // Оставляем только цифры
        value = value.replace(/\D/g, '');

        // Ограничение длины
        if (value.length > 20) value = value.slice(0, 20);

        setFormInfo(prev => ({
            ...prev,
            asset_value_gov: value
        }));
    };
    const handleAssetValueAMChange = (e) => {
        let value = e.target.value;

        // Оставляем только цифры
        value = value.replace(/\D/g, '');

        // Ограничение длины
        if (value.length > 20) value = value.slice(0, 20);

        setFormInfo(prev => ({
            ...prev,
            asset_value_am: value
        }));
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.asset_value_gov) {
            newErrors.asset_value_gov = 'Обязательное поле';
        }
        if (!formInfo.asset_value_gov) {
            newErrors.asset_value_am = 'Обязательное поле';
        }
        if (!formInfo.date_procedure_start_m) {
            newErrors.date_procedure_start_m = 'Обязательное поле';
        }
        if (!formInfo.date_procedure_start_r) {
            newErrors.date_procedure_start_r = 'Обязательное поле';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const changeData = () => {
        axios.put(`/api/change-case-insurance-gov`, {
            case_id: caseId,
            asset_value_gov: formInfo.asset_value_gov,
            asset_value_am: formInfo.asset_value_am,
            date_procedure_start_m: normalizeDate(formInfo.date_procedure_start_m),
            date_procedure_start_r: normalizeDate(formInfo.date_procedure_start_r),
        }).then(() => {
            setStatus('Данные изменены');
            openTimeModal('Данные успешно сохранены', 'success');
            closeModal();
            onSuccess();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            changeData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Редактирование балансовой стоимости активов должника</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата введения процедуры</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_procedure_start_m?.split('T')[0]}
                                onChange={handleChange('date_procedure_start_m')} 
                                className={errorsForm.date_procedure_start_m ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                <p className='description'>Полная версия</p>
                                {errorsForm.date_procedure_start_m && <div className='errorUnderInput'>{errorsForm.date_procedure_start_m}</div>}
                            </div>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_procedure_start_r?.split('T')[0]}
                                onChange={handleChange('date_procedure_start_r')} 
                                className={errorsForm.date_procedure_start_r ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                <p className='description'>Резолютивная часть</p>
                                {errorsForm.date_procedure_start_r && <div className='errorUnderInput'>{errorsForm.date_procedure_start_r}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Балансовая стоимость активов должника на момент введения процедуры по данным ФНС (₽)</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.asset_value_gov} 
                                onChange={handleAssetValueGovChange} 
                                className={errorsForm.asset_value_gov ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='20' 
                                disabled={loading}
                                required />
                                {errorsForm.asset_value_gov && <div className='errorUnderInput'>{errorsForm.asset_value_gov}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Балансовая стоимость активов должника по данным управляющего (₽)</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.asset_value_am} 
                                onChange={handleAssetValueAMChange} 
                                className={errorsForm.asset_value_am ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='20' 
                                disabled={loading}
                                required />
                                {errorsForm.asset_value_am && <div className='errorUnderInput'>{errorsForm.asset_value_am}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditInsuranceCase;